<template>
  <img src="/img/nib-logo-no-text.png" :height="height" :width="width" alt="NIB Logo" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
  setup() {
    return {};
  },
});
</script>

<style lang="postcss" scoped></style>
